// extracted by mini-css-extract-plugin
export var modal = "_t3-0";
export var table = "_t3-1";